import { Col, Form as BSForm, Row } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import ReactDatePicker from 'react-datepicker';
import SigniteToggle from '../../../../ui-elements/toggle-switch/signiteToggleSwitch';
import _ from 'lodash';
import { getErrorClass, getErrorMessage } from '../../../../../utils/errorUtils';
export const HighSchoolForm = ({ handleChange, handleBlur, values, errors, touched, initialized }) => {
  const { setFieldValue } = useFormikContext();
  return (
    <div className="signite-form">
      {
        <>
          <Row className="mb-3">
            <BSForm.Group as={Col} controlId="highSchoolSchoolName">
              <BSForm.Label>School Name</BSForm.Label>
              <BSForm.Control
                name={`highSchoolSchoolName`}
                value={values.highSchoolSchoolName}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`form-control ${getErrorClass(errors, touched, 'highSchoolSchoolName', initialized)}`}
                type="text"
              />
              <span className="errorMessage">
                {getErrorMessage(errors, touched, 'highSchoolSchoolName', initialized)}
              </span>
            </BSForm.Group>
            <BSForm.Group as={Col} controlId="courseType">
              <BSForm.Label>Start MM/YYYY</BSForm.Label>
              <ReactDatePicker
                name={'highSchoolStartDate'}
                selected={values.highSchoolStartDate ? new Date(values.highSchoolStartDate) : null}
                onChange={(val) => {
                  setFieldValue('highSchoolStartDate', val, true);
                }}
                onBlur={handleBlur}
                className={`form-control ${getErrorClass(errors, touched, 'highSchoolStartDate', initialized)}`}
                dateFormat="MM/yyyy"
                maxDate={new Date()}
                showMonthYearPicker
              />
              <span className="errorMessage">
                {getErrorMessage(errors, touched, 'highSchoolStartDate', initialized)}
              </span>
            </BSForm.Group>
            <BSForm.Group as={Col} controlId="blank">
              <BSForm.Label>End MM/YYYY</BSForm.Label>
              <ReactDatePicker
                name={'highSchoolEndDate'}
                selected={values.highSchoolEndDate ? new Date(values.highSchoolEndDate) : null}
                onChange={(val) => {
                  setFieldValue('highSchoolEndDate', val, true);
                }}
                onBlur={handleBlur}
                className={`form-control ${getErrorClass(errors, touched, 'highSchoolEndDate', initialized)}`}
                dateFormat="MM/yyyy"
                maxDate={new Date()}
                showMonthYearPicker
              />
              <span className="errorMessage">{getErrorMessage(errors, touched, 'highSchoolEndDate', initialized)}</span>
            </BSForm.Group>
          </Row>
          <Row className="mb-3">
            <BSForm.Group as={Col} controlId="blank">
              <BSForm.Label>CGPA/ Percentage</BSForm.Label>
              <BSForm.Control
                type="text"
                name="highSchoolCGPA"
                value={values.highSchoolCGPA}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`form-control ${getErrorClass(errors, touched, 'highSchoolCGPA', initialized)}`}
              />
              <span className="errorMessage">{getErrorMessage(errors, touched, 'highSchoolCGPA', initialized)}</span>
            </BSForm.Group>
            <BSForm.Group as={Col} controlId="blank">
              <BSForm.Label>Rank</BSForm.Label>
              <BSForm.Control
                type="number"
                name="highSchoolRank"
                onChange={handleChange}
                value={values.highSchoolRank}
                min={0}
                className={`form-control ${getErrorClass(errors, touched, 'highSchoolRank', initialized)}`}
              ></BSForm.Control>
              <span className="errorMessage">{getErrorMessage(errors, touched, `highSchoolRank`, initialized)}</span>
            </BSForm.Group>
            <BSForm.Group as={Col} controlId="blank"></BSForm.Group>
          </Row>
          <Row className="mb-3">
            <BSForm.Group as={Col} controlId="hashighSchoolBackLog">
              <BSForm.Label>Do you have any Backpapers,Drop Year?</BSForm.Label>
              <SigniteToggle
                id={'hashighSchoolBackLog'}
                dataYes={'Yes'}
                dataNo={'No'}
                fieldInput={{
                  onChange: handleChange,
                  value: values.hashighSchoolBackLog,
                }}
              />
            </BSForm.Group>
            <BSForm.Group as={Col} controlId="blank"></BSForm.Group>
            <BSForm.Group as={Col} controlId="blank"></BSForm.Group>
          </Row>
          {values.hashighSchoolBackLog && (
            <Row className="mb-3">
              <BSForm.Group as={Col} controlId="courseType">
                <BSForm.Label>Start MM/YYYY</BSForm.Label>
                <ReactDatePicker
                  name={'highSchoolBacklogStartDate'}
                  selected={values.highSchoolBacklogStartDate ? new Date(values.highSchoolBacklogStartDate) : null}
                  onChange={(val) => {
                    setFieldValue('highSchoolBacklogStartDate', val, true);
                  }}
                  onBlur={handleBlur}
                  className={`form-control ${getErrorClass(
                    errors,
                    touched,
                    'highSchoolBacklogStartDate',
                    initialized
                  )}`}
                  dateFormat="MM/yyyy"
                  maxDate={new Date()}
                  showMonthYearPicker
                />
                <span className="errorMessage">
                  {getErrorMessage(errors, touched, 'highSchoolBacklogStartDate', initialized)}
                </span>
              </BSForm.Group>
              <BSForm.Group as={Col} controlId="blank">
                <BSForm.Label>End MM/YYYY</BSForm.Label>
                <ReactDatePicker
                  name={'highSchoolBacklogEndDate'}
                  maxDate={new Date()}
                  selected={values.highSchoolBacklogEndDate ? new Date(values.highSchoolBacklogEndDate) : null}
                  onChange={(val) => {
                    setFieldValue('highSchoolBacklogEndDate', val, true);
                  }}
                  onBlur={handleBlur}
                  className={`form-control ${getErrorClass(errors, touched, 'highSchoolBacklogEndDate', initialized)}`}
                  dateFormat="MM/yyyy"
                  showMonthYearPicker
                />
                <span className="errorMessage">
                  {getErrorMessage(errors, touched, 'highSchoolBacklogEndDate', initialized)}
                </span>
              </BSForm.Group>
              <BSForm.Group as={Col} controlId="highSchoolBacklogReason">
                <BSForm.Label>Reason *</BSForm.Label>
                <BSForm.Control
                  name={`highSchoolBacklogReason`}
                  value={values.highSchoolBacklogReason}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={`form-control ${getErrorClass(errors, touched, 'highSchoolBacklogReason', initialized)}`}
                />
                <span className="errorMessage">
                  {getErrorMessage(errors, touched, 'highSchoolBacklogReason', initialized)}
                </span>
              </BSForm.Group>
            </Row>
          )}
        </>
      }
    </div>
  );
};
